import { ChakraProvider } from '@chakra-ui/react';
import { RouterProvider } from 'react-router';
import { system } from '@/styles/theme';
import { router } from '@/App/routes';
import { QueryProvider } from '@/providers/QueryProvider';
import { ToastContainer } from 'react-toastify';
import AlertModal from '@/components/AlertModal';

const App = () => (
  <QueryProvider>
    <ChakraProvider value={system}>
      <RouterProvider router={router} />
      <AlertModal />
    </ChakraProvider>
    <ToastContainer />
  </QueryProvider>
);

export default App;
